<script lang="ts">
    import Button from "../Components/Button.svelte";
    import {alertShown, modalCloseAction} from "../Core/Store";
    import {UnavailabilityReason} from "../Data/UnavailabilityData";
    import DateInput from "../Components/Input/DateInput.svelte";
    import {handApi} from "../Core/HandApi";
    import dayjs from "dayjs";

    export let data;

    let buttonSet = 0; // 1 = Delete, 2 = Add

    let day, month, isUnavailable, unavailability, isWorker, working = false;
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    $: {
        if (data) {
            isUnavailable = data.unavailable != null;
            unavailability = isUnavailable ? data.unavailable : null;
            isWorker = isUnavailable ? data.unavailable.isWorker : false;

            buttonSet = isUnavailable ? (isWorker ? 1 : 0) : 2;
        }
    }

    function formatDate(dateToFormat:Date) : String {
        return dayjs(dateToFormat).format('DD MMM HH:mm');
    }

    async function removeUnavailability() {
        if (working) return;
        working = true;

        let result = await handApi.removeUnavailability(unavailability.id);if (result) {
            alertShown.set(false);
            $modalCloseAction();
        } else {
            alert('Could not remove this.');
            working = false;
        }
    }

    let startDate = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate()),
        endDate:Date = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate(), 23, 59, 59),
        reason = UnavailabilityReason.Holiday,
        otherReason = '';
    async function addUnavailability() {
        if (working) return;
        working = true;
        let result = await handApi.setUnavailability(startDate, endDate, reason, otherReason);
        if (result) {
            alertShown.set(false);
            $modalCloseAction();
        } else {
            alert('Could not save this.');
            working = false;
        }
    }
</script>

<div>
    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
        Availability for {dayjs(data.date).format('DD MMMM')}
    </h3>
    <div class="mt-2">
        <p class="text-sm text-gray-500">
            {#if isUnavailable}
                {#if isWorker}
                    <p>You marked yourself as unavailable between {formatDate(unavailability.start)} and {formatDate(unavailability.end)}.
                    <p class="mt-2">Would you like to remove this?</p>
                {:else}
                    <p>Your agency has marked you as unavailable between {formatDate(unavailability.start)} and {formatDate(unavailability.end)}.</p>
                    <p class="mt-2">You should speak to your agency about changing this information if it's wrong.</p>
                {/if}
            {:else}
                <p>You're currently available on this date. Would you like to mark yourself as unavailable?</p>

                <div class="flex flex-col gap-2 mt-2">
                    <div class="text-xs font-medium">From</div>
                    <DateInput bind:date={startDate} class="block w-full text-gray-800 placeholder-gray-400 border-0 bg-gray-100 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm" />
                    <div class="text-xs font-medium">To</div>
                    <DateInput bind:date={endDate} class="block w-full text-gray-800 placeholder-gray-400 border-0 bg-gray-100 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm" />
                    <div class="text-xs font-medium">Why?</div>
                    <select bind:value={reason} class="block w-full text-gray-800 placeholder-gray-400 border-0 bg-gray-100 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm">
                        <option value={UnavailabilityReason.Holiday}>Holiday</option>
                        <option value={UnavailabilityReason.Sickness}>Sickness</option>
                        <option value={UnavailabilityReason.Other}>Other</option>
                    </select>
                    {#if reason === UnavailabilityReason.Other}
                        <div class="text-xs font-medium">Explain</div>
                        <textarea bind:value={otherReason} rows="2" class="block w-full text-gray-800 placeholder-gray-400 border-0 bg-gray-100 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm" placeholder="Enter reason here..."></textarea>
                    {/if}
                </div>
            {/if}
        </p>
    </div>
</div>
{#if buttonSet === 0}
<div class="mt-5 sm:mt-6">
    <Button on:click={() => alertShown.set(false)} styles="mx-auto block">
        Close Information
    </Button>
</div>
{:else if buttonSet === 1}
    <div class="mt-5 sm:mt-6 grid grid-cols-2 gap-2">
        <Button on:click={() => { if(!working) { alertShown.set(false) } } } styles="block" mode="secondary" loading={working}>
            Close
        </Button>
        <Button mode="danger" on:click={removeUnavailability} styles="block" loading={working}>
            Remove
        </Button>
    </div>
{:else}
    <div class="mt-5 sm:mt-6 grid grid-cols-2 gap-2">
        <Button on:click={() => { if(!working) { alertShown.set(false) } } } styles="block" mode="secondary" loading={working}>
            Close
        </Button>
        <Button on:click={addUnavailability} styles="block" loading={working}>
            Add
        </Button>
    </div>
{/if}